module.exports = {
    //Common Button
    "TNF_BTN_SEARCH": "ค้นหา",
    "TNF_BTN_CLEAR": "ล้างข้อมูล",
    "TNF_BTN_ADD": "เพิ่ม",

    "TNF_ACTIVE": "ใช้งาน",
    "TNF_INACTIVE": "ไม่ใช้งาน",
    'TNF_NO_COPEN' : 'No copen'
}
